<template>
  <v-app>
    <v-app-bar app color="blue" dark>
      <div class="d-flex align-center">
        <h1>Отчеты</h1>
      </div>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <v-form>
          <v-form class="ma-6 pa-0">
            <v-row>
              <v-col cols="3">
                <v-select
                  :items="managers"
                  v-model="selectManagers"
                  label="Подписант"
                  item-value="id"
                  item-text="name"
                  multiple
                  outlined
                  dense
                >
                </v-select>
              </v-col>
            </v-row>
            <v-btn
              color="success"
              class="mr-4"
              @click="getReport"
              :disabled="loading"
              small
            >
              сформировать
            </v-btn>
            <v-btn
              color="orange"
              class="mr-4"
              @click="exportXLS"
              :disabled="loading"
              small
            >
              EXPORT XLS
            </v-btn>
          </v-form>
        </v-form>
        <v-row>
          <v-col>
            <BarChart
              v-if="chartsOk"
              :chartdata="chartData"
              :options="options"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-simple-table dense fixed-header height="600px">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center gray">Менеджер</th>
                    <th colspan="8" class="text-center blue lighten-3">
                      Сделки с договорами
                    </th>
                    <th colspan="4" class="text-center yellow lighten-3">
                      Копии и пр.
                    </th>
                    <th colspan="5" class="text-center pink lighten-3">
                      Судебные экспертизы
                    </th>
                    <th class="text-center success">Итого</th>
                  </tr>
                  <tr>
                    <th
                      :class="`text-left ${item.color}`"
                      v-for="item in headers"
                      :key="item.text"
                    >
                      {{ item.text }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <StringTable
                    v-for="item in report"
                    :key="item.id"
                    :item-data="item"
                  >
                  </StringTable>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-container>
      <!--<v-container fluid>
        <v-form>
          <v-form class="ma-6 pa-0">
            <v-row>
              <v-col cols="3" sm="6" md="4">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dates"
                      label="Дата заключения"
                      placeholder="Текущий месяц"
                      prepend-icon="mdi-calendar"
                      readonly
                      clearable
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dates"
                    range
                    locale="ru-RU"
                    :first-day-of-week="1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      Отмена
                    </v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(dates)">
                      Сохранить
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="3">
                <v-select
                  :items="managers"
                  v-model="selectManagersCountDeals"
                  label="Подписант"
                  item-value="id"
                  item-text="name"
                  multiple
                  outlined
                  dense
                >
                </v-select>
              </v-col>
            </v-row>
            <v-btn
              color="success"
              class="mr-4"
              @click="getReportCountDeals"
              :disabled="loadingCountDeals"
              small
            >
              сформировать
            </v-btn>
            <v-btn
              color="orange"
              class="mr-4"
              @click="exportXLS('countDeals')"
              :disabled="loadingCountDeals"
              small
            >
              EXPORT XLS
            </v-btn>
          </v-form>
        </v-form>
        <v-row>
          <v-col>
            <BarChart
              v-if="chartsCountReportOk"
              :chartdata="chartDataCountDeals"
              :options="optionsCountDeals"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-simple-table class="ma-3 pa-3" height="600px">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left gray">Менеджер</th>
                    <th class="text-left blue lighten-3">Экспертиза</th>
                    <th class="text-left yellow lighten-3">Копии и пр.</th>
                    <th class="text-left pink lighten-3">
                      Судебные экспертизы
                    </th>
                    <th class="text-left success">Итого</th>
                  </tr>
                </thead>
                <template v-if="loadingCountDeals === true">
                  <v-progress-linear
                    :active="loadingCountDeals"
                    :indeterminate="loadingCountDeals"
                    absolute
                    top
                    color="light-green darken-4"
                    height="10"
                  ></v-progress-linear>
                </template>
                <tbody v-if="reportCountDeals.length > 0">
                  <template v-for="item in reportCountDeals">
                    <tr :key="item.manager">
                      <td class="text-left gray">{{ item.manager }}</td>
                      <td class="text-left blue lighten-3">
                        {{ item.contract }}
                      </td>
                      <td class="text-left yellow lighten-3">
                        {{ item.notContract }}
                      </td>
                      <td class="text-left pink lighten-3">
                        {{ item.expertise }}
                      </td>
                      <td class="text-left success">{{ item.total }}</td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-container>-->
      <v-container fluid>
        <v-form>
          <v-form class="ma-6 pa-0">
            <v-row>
              <v-col cols="3" sm="6" md="4">
                <v-menu
                  ref="menuTwo"
                  v-model="menuTwo"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="datesTwo"
                      label="Дата заключения"
                      placeholder="Текущий месяц"
                      prepend-icon="mdi-calendar"
                      readonly
                      clearable
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="datesTwo"
                    range
                    locale="ru-RU"
                    :first-day-of-week="1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menuTwo = false">
                      Отмена
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menuTwo.save(datesTwo)"
                    >
                      Сохранить
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="3">
                <v-select
                  :items="managers"
                  v-model="selectManagersCountDealsTwo"
                  label="Подписант"
                  item-value="id"
                  item-text="name"
                  multiple
                  outlined
                  dense
                >
                </v-select>
              </v-col>
            </v-row>
            <v-btn
              color="success"
              class="mr-4"
              @click="getReportCountDealsTwo"
              :disabled="loadingCountDealsTwo"
              small
            >
              сформировать
            </v-btn>
            <v-btn
              color="orange"
              class="mr-4"
              @click="exportXLS('countDealsTwo')"
              :disabled="loadingCountDealsTwo"
              small
            >
              EXPORT XLS
            </v-btn>
          </v-form>
        </v-form>
        <v-row>
          <v-col>
            <BarChart
              v-if="chartsCountReportOkTwo"
              :chartdata="chartDataCountDealsTwo"
              :options="optionsCountDealsTwo"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-simple-table class="ma-3 pa-3" height="600px">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left gray">Эксперт</th>
                    <th class="text-left cyan lighten-4">
                      Договор и предоплата.
                    </th>
                    <th class="text-left blue lighten-3">Производство</th>
                    <th class="text-left yellow lighten-3">Проект направлен</th>
                    <th class="text-left pink lighten-3">Выдано экспертиз</th>
                    <th class="text-left success">Итого</th>
                    <th class="text-left orange lighten-3">Копии</th>
                    <th class="text-left success lighten-3">Фин результат</th>
                  </tr>
                </thead>
                <template v-if="loadingCountDealsTwo === true">
                  <v-progress-linear
                    :active="loadingCountDealsTwo"
                    :indeterminate="loadingCountDealsTwo"
                    absolute
                    top
                    color="light-green darken-4"
                    height="10"
                  ></v-progress-linear>
                </template>
                <tbody v-if="reportCountDealsTwo.length > 0">
                  <template v-for="item in reportCountDealsTwo">
                    <tr :key="item.manager">
                      <td class="text-left gray">{{ item.manager }}</td>
                      <td class="text-left cyan lighten-4">
                        {{ item.contract }}
                      </td>
                      <td class="text-left blue lighten-3">
                        {{ item.productions }}
                      </td>
                      <td class="text-left yellow lighten-3">
                        {{ item.notContract }}
                      </td>
                      <td class="text-left pink lighten-3">
                        {{ item.expertise }}
                      </td>
                      <td class="text-left success">{{ item.total }}</td>
                      <td class="text-left orange lighten-3">
                        {{ item.copy }}
                      </td>
                      <td class="text-left success lighten-3">
                        {{
                          new Intl.NumberFormat("ru-RU", {
                            minimumFractionDigits: 2,
                          }).format(item.fin)
                        }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-container>

    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import exeljs from "exceljs";
import fileWrite from "file-saver";
import StringTable from "@/components/StringTable";
import BarChart from "@/components/BarChart.js";

export default {
  name: "App",
  data: () => ({
    dates: [],
    datesTwo: [],
    datesTree: [],
    datesCreate: [],
    saleDates: [],
    menu: false,
    menuTwo: false,
    menuTree: false,
    menuCreate: false,
    chartsOk: false,
    chartsOkSTE: false,
    chartsCountReportOk: false,
    chartsCountReportOkTwo: false,
    chartsSalesReportOk: false,
    chartData: {},
    chartDataSTE: {},
    chartDataCountDeals: {},
    chartDataCountDealsTwo: {},
    chartDataSalesProducts1: {},
    chartDataSalesProducts2: {},
    options: {},
    optionsSTE: {},
    optionsCountDeals: {},
    optionsCountDealsTwo: {},
    optionsSalesProducts: {},
    managers: [],
    selectManagers: [],
    typeSTE: [],
    selectTypeSTE: [],
    products: [],
    selectManagersToSalesReport: [],
    selectManagersCountDeals: [],
    selectManagersCountDealsTwo: [],
    loading: false,
    headers: [
      { color: "gray", text: "Подписант" },
      { color: "blue lighten-3", text: "Обращения (не разобранное)" },
      { color: "blue lighten-3", text: "Клиент (лид)" },
      { color: "blue lighten-3", text: "Сбор информации (встреча)" },
      { color: "blue lighten-3", text: "Договор и предоплата" },
      { color: "blue lighten-3", text: "Производство" },
      { color: "blue lighten-3", text: "Проект направлен" },
      { color: "blue lighten-3", text: "ГОТОВО! (проект согласован)" },
      { color: "blue lighten-3", text: "Выданные (Закрывающие документы)" },
      { color: "yellow lighten-3", text: "Клиент(лид)" },
      { color: "yellow lighten-3", text: "Сбор информации(встреча)" },
      { color: "yellow lighten-3", text: "Консультация" },
      { color: "yellow lighten-3", text: "Оплата" },
      { color: "pink lighten-3", text: "Вынесено определение (постановление)" },
      { color: "pink lighten-3", text: "Определение получено" },
      { color: "pink lighten-3", text: "Направлено ходатайство" },
      {
        color: "pink lighten-3",
        text: "Производство (получен ответ и/или материалы)",
      },
      { color: "pink lighten-3", text: "Выдано, ожидаем оплату" },
      { color: "success", text: "Итого" },
    ],
    url: "https://sudexpert.bitrix24.ru/rest/816/v3rsh7wds1p4roy5/",
    report: [],
    reportSTE: [],
    reportCountDeals: [],
    reportCountDealsTwo: [],
    saleProductsReport: [],
    saleDealsReportTotal: {
      quantity: 0,
      sum: 0,
      sumXls: 0,
    },
    loadingSaleProducts: false,
    saleDeals: [],
    saleDealsReport: [],
    normalDateSales: [],
    loadingCountDeals: false,
    loadingCountDealsTwo: false,
    loadingSTE: false,
    deals: [],
    dealsCountReport: [],
    dealsSTE: [],
    normalDate: [],
    properties: [],
    pieChartData: {},
    pieOptions: {
      responsive: true,
      maintainAspectRatio: false,
    },
    steSummary: [],
  }),
  components: { StringTable, BarChart },
  methods: {
    async getReportCountDealsTwo() {
      try {
        this.optionsCountDealsTwo = {};
        this.chartDataCountDealsTwo = {};
        this.dealsCountReportTwo = [];
        this.reportCountDealsTwo = [];
        this.loadingCountDealsTwo = true;
        this.chartsCountReportOkTwo = false;

        const nowDate = new Date();
        let month = nowDate.getMonth() + 1;
        const year = nowDate.getFullYear();

        if (String(month).length) {
          if (String(month).length == 1) month = `0${month}`;
          else month = `${month}`;
        }
        let i = 1;
        let start = 0;
        while (i > 0) {
          const params = {
            filter: {},
            select: [
              "ID",
              "STAGE_ID",
              "UF_CRM_1620922242",
              "CATEGORY_ID",
              "OPPORTUNITY",
            ],
            start: start,
          };
          if (this.datesTwo.length == 0) {
            this.datesTwo = [`${year}-${month}-01`, `${year}-${month}-31`];
          }
          await this.normalizeDate("salesTwo");
          params.filter[">=UF_CRM_1615821351"] = this.normalDate[0];
          params.filter["<=UF_CRM_1615821351"] = this.normalDate[1];

          const dealsData = await axios.post(
            this.url + "crm.deal.list",
            params
          );

          this.dealsCountReportTwo.push(...dealsData.data.result);

          if (dealsData.data.next) {
            start = dealsData.data.next;
          } else {
            i = 0;
          }
        }

        i = 1;
        start = 0;

        while (i > 0) {
          const params = {
            filter: {
              STAGE_ID: ["EXECUTING", "6"],
            },
            select: [
              "ID",
              "STAGE_ID",
              "UF_CRM_1620922242",
              "CATEGORY_ID",
              "OPPORTUNITY",
            ],
            start: start,
          };
          console.log({ params });

          const dealsData = await axios.post(
            this.url + "crm.deal.list",
            params
          );
          console.log({ dealsData });
          this.dealsCountReportTwo.push(...dealsData.data.result);

          if (dealsData.data.next) {
            start = dealsData.data.next;
          } else {
            i = 0;
          }
        }

        let searchManager = this.managers;
        if (this.selectManagersCountDealsTwo.length > 0) {
          searchManager = [];
          //console.log(this.selectManagersCountDeals, 'selectManager')
          for (const selectManagers of this.selectManagersCountDealsTwo) {
            if (selectManagers[0] != 56) {
              searchManager.push(
                this.managers.filter((e) => e.id == selectManagers)[0]
              );
            }
          }
        }
        //console.log({searchManager})
        //console.log(this.reportCountDeals, 'massive')
        this.reportCountDealsTwo = [];
        for (const manager of searchManager) {
          const filterDeals = this.dealsCountReportTwo.filter((e) => {
            if (e.UF_CRM_1620922242) {
              return e.UF_CRM_1620922242.findIndex((i) => i == manager.id) > -1;
            }
          });
          if (filterDeals.length > 0) {
            const itemToCountReport = {
              manager: manager.name,
              contract: 0,
              productions: 0,
              notContract: 0,
              expertise: 0,
              total: 0,
              copy: 0,
              fin: 0,
            };

            for (const deal of filterDeals) {
              // в отчет по успешным
              // console.log(deal.CATEGORY_ID)
              if (deal.CATEGORY_ID == 0 && deal.STAGE_ID == "6") {
                itemToCountReport.contract += 1;
                itemToCountReport.total += 1;
                //itemToCountReport.fin += Number(deal.OPPORTUNITY);
              }
              if (deal.CATEGORY_ID == 0 && deal.STAGE_ID == "EXECUTING") {
                itemToCountReport.productions += 1;
                itemToCountReport.total += 1;
                itemToCountReport.fin += Number(deal.OPPORTUNITY);
              }
              if (deal.CATEGORY_ID == 0 && deal.STAGE_ID == "UC_Z58WWQ") {
                itemToCountReport.notContract += 1;
                itemToCountReport.total += 1;
                itemToCountReport.fin += Number(deal.OPPORTUNITY);
              }
              if (
                (deal.CATEGORY_ID == 0 && deal.STAGE_ID == "WON") ||
                (deal.CATEGORY_ID == 0 && deal.STAGE_ID == "3") ||
                (deal.CATEGORY_ID == 0 && deal.STAGE_ID == "FINAL_INVOICE")
              ) {
                itemToCountReport.expertise += 1;
                itemToCountReport.total += 1;
                itemToCountReport.fin += Number(deal.OPPORTUNITY);
              }
              if (deal.CATEGORY_ID == 6 && deal.STAGE_ID == "C6:WON") {
                itemToCountReport.copy += 1;
                itemToCountReport.fin += Number(deal.OPPORTUNITY);
              }
            }

            this.reportCountDealsTwo.push(itemToCountReport);
            console.log({ filterDeals });
          }
        }
        //const dataCharts =
        this.chartDataCountDealsTwo = {
          labels: this.reportCountDealsTwo.map((e) => e.manager),
          datasets: [
            {
              label: "Договор и предоплата.",
              backgroundColor: "#B2EBF2",
              data: this.reportCountDealsTwo.map((e) => e.contract),
            },
            {
              label: "Производство",
              backgroundColor: "#90CAF9",
              data: this.reportCountDealsTwo.map((e) => e.productions),
            },
            {
              label: "Проект направлен",
              backgroundColor: "#fff59d",
              data: this.reportCountDealsTwo.map((e) => e.notContract),
            },
            {
              label: "Выдано экспертиз",
              backgroundColor: "#f48fb1",
              data: this.reportCountDealsTwo.map((e) => e.expertise),
            },
            {
              label: "Копии",
              backgroundColor: "#ff9800",
              data: this.reportCountDealsTwo.map((e) => e.copy),
            },
          ],
        };
        this.optionsCountDealsTwo = {
          responsive: true,
          maintainAspectRatio: false,
          events: [],
          scales: {
            yAxes: [
              {
                display: true,
                ticks: {
                  precision: 1, // точность округления значений по оси y
                  maxTicksLimit: 9, // максимальное количество значений (и рёбер сетки) по оси y
                },
              },
            ],
          },
        };
        this.chartsCountReportOkTwo = true;
        this.loadingCountDealsTwo = false;
      } catch (e) {
        console.log(e);
      }
    },
    async exportXLS(type = "first") {
      try {
        const workbook = new exeljs.Workbook();
        workbook.views = [
          {
            x: 0,
            y: 500,
            width: 29040,
            height: 15840,
            visibility: "visible",
          },
        ];
        const worksheet = workbook.addWorksheet("Отчет по подписантам");
        let report = [];
        if (type == "first") {
          report = this.report;
          worksheet.columns = [
            { header: "Подписант", key: "manager", width: 15 },
            {
              header: "Обращения (не разобранное)",
              key: "firstStage",
              width: 25,
              style: { numFmt: "#0" },
            },
            {
              header: "Клиент (лид)",
              key: "secondStage",
              width: 12,
              style: { numFmt: "#0" },
            },
            {
              header: "Сбор информации (встреча)",
              key: "thirdStage",
              width: 25,
              style: { numFmt: "#0" },
            },
            {
              header: "Договор и предоплата",
              key: "fourthStage",
              width: 19,
              style: { numFmt: "#0" },
            },
            {
              header: "Производство",
              key: "fifthStage",
              width: 12,
              style: { numFmt: "#0" },
            },
            {
              header: "Проект направлен",
              key: "sixthStage",
              width: 19,
              style: { numFmt: "#0" },
            },
            {
              header: "ГОТОВО! (проект согласован)",
              key: "seventhStage",
              width: 25,
              style: { numFmt: "#0" },
            },
            {
              header: "Выданные (Закрывающие документы)",
              key: "eighthStage",
              width: 25,
              style: { numFmt: "#0" },
            },
            {
              header: "Клиент(лид)",
              key: "ninthStage",
              width: 12,
              style: { numFmt: "#0" },
            },
            {
              header: "Сбор информации(встреча)",
              key: "tenthStage",
              width: 25,
              style: { numFmt: "#0" },
            },
            {
              header: "Консультация",
              key: "eleventhStage",
              width: 12,
              style: { numFmt: "#0" },
            },
            {
              header: "Оплата",
              key: "twelfthStage",
              width: 10,
              style: { numFmt: "#0" },
            },
            {
              header: "Вынесено определение (постановление)",
              key: "thirdtenStage",
              width: 10,
              style: { numFmt: "#0" },
            },
            {
              header: "Определение получено",
              key: "fourtenStage",
              width: 10,
              style: { numFmt: "#0" },
            },
            {
              header: "Направлено ходатайство",
              key: "fivetenStage",
              width: 10,
              style: { numFmt: "#0" },
            },
            {
              header: "Производство (получен ответ и/или материалы)",
              key: "sixtenStage",
              width: 10,
              style: { numFmt: "#0" },
            },
            {
              header: "Выдано, ожидаем оплату",
              key: "sevenStage",
              width: 10,
              style: { numFmt: "#0" },
            },
            {
              header: "Итого",
              key: "total",
              width: 10,
              style: { numFmt: "#0" },
            },
          ];
        } else if (type == "countDeals") {
          report = this.reportCountDeals;
          worksheet.columns = [
            { header: "Подписант", key: "manager", width: 15 },
            {
              header: "Экспертиза",
              key: "contract",
              width: 12,
              style: { numFmt: "#0" },
            },
            {
              header: "Копии и пр.",
              key: "notContract",
              width: 12,
              style: { numFmt: "#0" },
            },
            {
              header: "Судебные экспертизы",
              key: "expertise",
              width: 12,
              style: { numFmt: "#0" },
            },
            {
              header: "Итого",
              key: "total",
              width: 25,
              style: { numFmt: "#0" },
            },
          ];
        } else {
          report = this.reportCountDealsTwo;
          worksheet.columns = [
            { header: "Эксперт", key: "manager", width: 15 },
            {
              header: "Договор и предоплата",
              key: "contract",
              width: 12,
              style: { numFmt: "#,0" },
            },
            {
              header: "Производство",
              key: "productions",
              width: 12,
              style: { numFmt: "#,0" },
            },
            {
              header: "Проект направлен",
              key: "notContract",
              width: 12,
              style: { numFmt: "#,0" },
            },
            {
              header: "Выдано экспертиз",
              key: "expertise",
              width: 12,
              style: { numFmt: "#,0" },
            },
            {
              header: "Итого",
              key: "total",
              width: 25,
              style: { numFmt: "#,0" },
            },
            {
              header: "Копии",
              key: "copy",
              width: 25,
              style: { numFmt: "#,0" },
            },
            {
              header: "Фин результат",
              key: "fin",
              width: 25,
              style: { numFmt: "#,0.00" },
            },
          ];
        }
        for (const item of report) {
          const row = {
            ...item,
          };
          const itemRow = worksheet.addRow(row);
          /*itemRow.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: '669DBA'},
          };*/
          itemRow.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }

        const buffer = await workbook.xlsx.writeBuffer();
        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blob = new Blob([buffer], { type: fileType });
        fileWrite(blob, "Отчет по подписантам.xlsx");
      } catch (e) {
        console.log(e);
      }
    },
    async getReport() {
      try {
        this.report = [];
        this.loading = true;
        this.chartsOk = false;
        this.options = {};
        this.chartData = {};
        let i = 1;
        let start = 0;
        while (i > 0) {
          const dealsData = await axios.post(this.url + "crm.deal.list", {
            filter: { CLOSED: "N" },
            select: ["ID", "STAGE_ID", "UF_CRM_1620922242", "CATEGORY_ID"],
            start: start,
          });
          for (const deal of dealsData.data.result) {
            this.deals.push(deal);
          }
          if (dealsData.data.next) {
            start = dealsData.data.next;
          } else {
            i = 0;
          }
        }
        let searchManager = this.managers;
        if (this.selectManagers.length > 0) {
          searchManager = [];
          //console.log(this.selectManagers, 'selectManager')
          for (const selectManagers of this.selectManagers) {
            searchManager.push(
              this.managers.filter((e) => e.id == selectManagers)[0]
            );
          }
        }
        //console.log({searchManager})
        let maxDeals = 0;
        for (const manager of searchManager) {
          const filterDeals = this.deals.filter((e) => {
            return e.UF_CRM_1620922242.findIndex((i) => i == manager.id) > -1;
          });
          if (filterDeals.length > 0) {
            const item = {
              manager: manager.name,
              firstStage: 0,
              secondStage: 0,
              thirdStage: 0,
              fourthStage: 0,
              fifthStage: 0,
              sixthStage: 0,
              seventhStage: 0,
              eighthStage: 0,
              ninthStage: 0,
              tenthStage: 0,
              eleventhStage: 0,
              twelfthStage: 0,
              thirdtenStage: 0,
              fourtenStage: 0,
              fivetenStage: 0,
              sixtenStage: 0,
              sevenStage: 0,
              total: 0,
            };

            for (const deal of filterDeals) {
              //в отчет по рабочим
              switch (deal.STAGE_ID) {
                case "NEW":
                  item.firstStage += 1;
                  break;
                case "1":
                  item.secondStage += 1;
                  break;
                case "5":
                  item.thirdStage += 1;
                  break;
                case "6":
                  item.fourthStage += 1;
                  break;
                case "EXECUTING":
                  item.fifthStage += 1;
                  break;
                case "UC_Z58WWQ":
                  item.sixthStage += 1;
                  break;
                case "FINAL_INVOICE":
                  item.seventhStage += 1;
                  break;
                case "3":
                  item.eighthStage += 1;
                  break;
                case "C6:NEW":
                  item.ninthStage += 1;
                  break;
                case "C6:PREPARATION":
                  item.tenthStage += 1;
                  break;
                case "C6:EXECUTING":
                  item.eleventhStage += 1;
                  break;
                case "C6:PREPAYMENT_INVOICE":
                  item.twelfthStage += 1;
                  break;
                case "C16:NEW":
                  item.thirdtenStage += 1;
                  break;
                case "C16:PREPARATION":
                  item.fourtenStage += 1;
                  break;
                case "C16:PREPAYMENT_INVOIC":
                  item.fivetenStage += 1;
                  break;
                case "C16:EXECUTING":
                  item.sixtenStage += 1;
                  break;
                case "C16:FINAL_INVOICE":
                  item.sevenStage += 1;
                  break;
              }
              item.total += 1;
            }

            this.report.push(item);
            //console.log({filterDeals})
            if (item.total > maxDeals) maxDeals = item.total;
          }
        }
        //const dataCharts =
        this.chartData = {
          labels: this.report.map((e) => e.manager),
          datasets: [
            {
              label: "Клиент (лид)",
              backgroundColor: "#FBE7C6",
              data: this.report.map((e) => e.secondStage),
            },
            {
              label: "Сбор информации (встреча)",
              backgroundColor: "#F8D210",
              data: this.report.map((e) => e.thirdStage),
            },
            {
              label: "Договор и предоплата",
              backgroundColor: "#0E86D4",
              data: this.report.map((e) => e.fourthStage),
            },
            {
              label: "Производство",
              backgroundColor: "#76B947",
              data: this.report.map((e) => e.fifthStage),
            },
            {
              label: "Проект направлен",
              backgroundColor: "#36EEE0",
              data: this.report.map((e) => e.sixthStage),
            },
          ],
        };

        this.options = {
          responsive: true,
          maintainAspectRatio: false,
          events: [],
          scales: {
            yAxes: [
              {
                display: true,
                ticks: {
                  precision: 1, // точность округления значений по оси y
                  maxTicksLimit: 9, // максимальное количество значений (и рёбер сетки) по оси y
                },
              },
            ],
          },
        };
        this.chartsOk = true;
        this.loading = false;
        console.log(this.report);
      } catch (e) {
        console.log(e);
      }
    },
    async getReportSTE() {
      try {
        this.reportSTE = [];
        this.loadingSTE = true;
        this.chartsOkSTE = false;
        this.optionsSTE = {};
        this.chartDataSTE = {};
        this.dealsSTE = [];
        this.steSummary = [];
        await this.normalizeDate("STE");
        console.log(this.normalDate);
        let i = 1;
        let start = 0;
        while (i > 0) {
          const params = {
            filter: {
              ">=UF_CRM_1620921006": this.normalDate[0],
              "<=UF_CRM_1620921006": this.normalDate[1],
              CATEGORY_ID: "18",
            },
            select: [
              "ID",
              "TITLE",
              "STAGE_ID",
              "UF_CRM_1620921006",
              "UF_CRM_1736762988",
              "CATEGORY_ID",
              "OPPORTUNITY",
            ],
            start: start,
          };
          if (this.selectTypeSTE.length > 0) {
            params.filter["UF_CRM_1736762988"] = this.selectTypeSTE;
          }
          console.log({ params });
          const dealsData = await axios.post(
            this.url + "crm.deal.list",
            params
          );
          console.log({ dealsData });
          for (const deal of dealsData.data.result) {
            this.dealsSTE.push(deal);
          }
          if (dealsData.data.next) {
            start = dealsData.data.next;
          } else {
            i = 0;
          }
        }
        console.log(this.dealsSTE);
        //формируем сумму по отдельности на каждый тип СТЭ
        const steSummaryArray = this.dealsSTE.reduce((acc, deal) => {
          const steType = deal.UF_CRM_1736762988 || "Без типа";
          const opportunity = parseFloat(deal.OPPORTUNITY) || 0;

          if (!acc[steType]) {
            const typeInfo = this.typeSTE.find((e) => String(e.ID) === steType);
            const title = typeInfo ? typeInfo.VALUE : `Тип ${steType}`;

            acc[steType] = {
              title: title,
              type: steType,
              count: 0,
              totalOpportunity: 0,
            };
          }

          acc[steType].count++;
          acc[steType].totalOpportunity += opportunity;

          return acc;
        }, {});

        // Преобразуем в массив
        this.steSummary = Object.values(steSummaryArray).filter(
          (item) => item.count > 0
        );
        console.log(this.steSummary);
        //const dataCharts =
        this.chartDataSTE = {
          labels: this.steSummary.map((e) => e.title),
          datasets: [
            {
              backgroundColor: this.generateColors(this.steSummary.length),
              data: this.steSummary.map((e) => e.totalOpportunity),
            },
          ],
        };

        this.chartsOkSTE = true;
        this.loadingSTE = false;
        //console.log(this.reportSTE);
      } catch (e) {
        console.log(e);
      }
    },
    generateColors(count) {
      const colors = [
        "#41B883",
        "#E46651",
        "#00D8FF",
        "#FFCE56",
        "#9C27B0",
        "#FF9800",
        "#2196F3",
        "#4CAF50",
      ];
      return colors.slice(0, count);
    },
    async getReportCountDeals() {
      try {
        this.optionsCountDeals = {};
        this.chartDataCountDeals = {};
        this.dealsCountReport = [];
        this.reportCountDeals = [];
        this.loadingCountDeals = true;
        this.chartsCountReportOk = false;

        const nowDate = new Date();
        let month = nowDate.getMonth() + 1;
        const year = nowDate.getFullYear();

        if (String(month).length) {
          if (String(month).length == 1) month = `0${month}`;
          else month = `${month}`;
        }
        this.normalDate = [
          `01.${month}.${year} 00:00:00`,
          `31.${month}.${year} 23:59:59`,
        ];
        let i = 1;
        let start = 0;
        while (i > 0) {
          const params = {
            filter: {},
            select: ["ID", "STAGE_ID", "UF_CRM_1620922242", "CATEGORY_ID"],
            start: start,
          };
          if (this.dates.length > 0) {
            await this.normalizeDate();
          }

          params.filter[">=UF_CRM_1615821351"] = this.normalDate[0];
          params.filter["<=UF_CRM_1615821351"] = this.normalDate[1];
          console.log({ params });

          const dealsData = await axios.post(
            this.url + "crm.deal.list",
            params
          );
          console.log({ dealsData });
          for (const deal of dealsData.data.result) {
            this.dealsCountReport.push(deal);
          }
          if (dealsData.data.next) {
            start = dealsData.data.next;
          } else {
            i = 0;
          }
        }
        let searchManager = this.managers;
        if (this.selectManagersCountDeals.length > 0) {
          searchManager = [];
          //console.log(this.selectManagersCountDeals, 'selectManager')
          for (const selectManagers of this.selectManagersCountDeals) {
            if (selectManagers[0] != 56) {
              searchManager.push(
                this.managers.filter((e) => e.id == selectManagers)[0]
              );
            }
          }
        }
        //console.log({searchManager})
        //console.log(this.reportCountDeals, 'massive')
        this.reportCountDeals = [];
        for (const manager of searchManager) {
          const filterDeals = this.dealsCountReport.filter((e) => {
            if (e.UF_CRM_1620922242) {
              return e.UF_CRM_1620922242.findIndex((i) => i == manager.id) > -1;
            }
          });
          if (filterDeals.length > 0) {
            const itemToCountReport = {
              manager: manager.name,
              contract: 0,
              notContract: 0,
              expertise: 0,
              total: 0,
            };

            for (const deal of filterDeals) {
              // в отчет по успешным
              // console.log(deal.CATEGORY_ID)
              if (
                (deal.CATEGORY_ID == 0 && deal.STAGE_ID == "WON") ||
                (deal.CATEGORY_ID == 0 && deal.STAGE_ID == "3") ||
                (deal.CATEGORY_ID == 0 && deal.STAGE_ID == "FINAL_INVOICE")
              ) {
                itemToCountReport.contract += 1;
                itemToCountReport.total += 1;
              }
              if (deal.CATEGORY_ID == 6 && deal.STAGE_ID == "C6:WON") {
                itemToCountReport.notContract += 1;
                itemToCountReport.total += 1;
              }
              if (
                (deal.CATEGORY_ID == 16 && deal.STAGE_ID == "C16:WON") ||
                (deal.CATEGORY_ID == 16 && deal.STAGE_ID == "C16:FINAL_INVOICE")
              ) {
                itemToCountReport.expertise += 1;
                itemToCountReport.total += 1;
              }
            }

            this.reportCountDeals.push(itemToCountReport);
            console.log({ filterDeals });
          }
        }
        //const dataCharts =
        this.chartDataCountDeals = {
          labels: this.reportCountDeals.map((e) => e.manager),
          datasets: [
            {
              label: "С договором",
              backgroundColor: "#90CAF9",
              data: this.reportCountDeals.map((e) => e.contract),
            },
            {
              label: "Без договора",
              backgroundColor: "#fff59d",
              data: this.reportCountDeals.map((e) => e.notContract),
            },
            {
              label: "Судебная экспертиза",
              backgroundColor: "#f48fb1",
              data: this.reportCountDeals.map((e) => e.expertise),
            },
          ],
        };
        this.optionsCountDeals = {
          responsive: true,
          maintainAspectRatio: false,
          events: [],
          scales: {
            yAxes: [
              {
                display: true,
                ticks: {
                  precision: 1, // точность округления значений по оси y
                  maxTicksLimit: 9, // максимальное количество значений (и рёбер сетки) по оси y
                },
              },
            ],
          },
        };
        this.chartsCountReportOk = true;
        this.loadingCountDeals = false;
      } catch (e) {
        console.log(e);
      }
    },
    async normalizeDate(type = "notSale") {
      try {
        if (type === "sale") {
          console.log(this.saleDates);
          this.normalDateSales = [];
          const firstDate = this.saleDates[0].split("-");
          const twoDate = this.saleDates[1].split("-");
          const firstDateFormated =
            firstDate[2] +
            "." +
            firstDate[1] +
            "." +
            firstDate[0] +
            " 00:00:00";
          const twoDateFormated =
            twoDate[2] + "." + twoDate[1] + "." + twoDate[0] + " 23:59:59";
          this.normalDateSales.push(firstDateFormated);
          this.normalDateSales.push(twoDateFormated);
        } else if (type == "salesTwo") {
          this.normalDate = [];
          const firstDate = this.datesTwo[0].split("-");
          const twoDate = this.datesTwo[1].split("-");
          const firstDateFormated =
            firstDate[2] +
            "." +
            firstDate[1] +
            "." +
            firstDate[0] +
            " 00:00:00";
          const twoDateFormated =
            twoDate[2] + "." + twoDate[1] + "." + twoDate[0] + " 23:59:59";
          this.normalDate.push(firstDateFormated);
          this.normalDate.push(twoDateFormated);
        } else if (type == "create") {
          this.normalDate = [];
          const firstDate = this.datesCreate[0].split("-");
          const twoDate = this.datesCreate[1].split("-");
          const firstDateFormated =
            firstDate[2] +
            "." +
            firstDate[1] +
            "." +
            firstDate[0] +
            " 00:00:00";
          const twoDateFormated =
            twoDate[2] + "." + twoDate[1] + "." + twoDate[0] + " 23:59:59";
          this.normalDate.push(firstDateFormated);
          this.normalDate.push(twoDateFormated);
        } else if (type == "STE") {
          this.normalDate = [];
          const firstDate = this.datesTree[0].split("-");
          const twoDate = this.datesTree[1].split("-");
          const firstDateFormated =
            firstDate[2] +
            "." +
            firstDate[1] +
            "." +
            firstDate[0] +
            " 00:00:00";
          const twoDateFormated =
            twoDate[2] + "." + twoDate[1] + "." + twoDate[0] + " 23:59:59";
          this.normalDate.push(firstDateFormated);
          this.normalDate.push(twoDateFormated);
        } else {
          this.normalDate = [];
          const firstDate = this.dates[0].split("-");
          const twoDate = this.dates[1].split("-");
          const firstDateFormated =
            firstDate[2] +
            "." +
            firstDate[1] +
            "." +
            firstDate[0] +
            " 00:00:00";
          const twoDateFormated =
            twoDate[2] + "." + twoDate[1] + "." + twoDate[0] + " 23:59:59";
          this.normalDate.push(firstDateFormated);
          this.normalDate.push(twoDateFormated);
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getManager() {
      try {
        const managersData = await axios.post(this.url + "user.search", {
          filter: { ACTIVE: "true", UF_DEPARTMENT: 146 },
        });
        for (const manager of managersData.data.result) {
          this.managers.push({
            id: manager.ID,
            name: `${manager.LAST_NAME} ${manager.NAME}`,
          });
        }
        const managersData2 = await axios.post(this.url + "user.search", {
          filter: { ACTIVE: "true", UF_DEPARTMENT: 150 },
        });
        for (const manager of managersData2.data.result) {
          this.managers.push({
            id: manager.ID,
            name: `${manager.LAST_NAME} ${manager.NAME}`,
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getSTE() {
      try {
        const params = { id: "2260" };
        const steData = await axios.post(
          this.url + "crm.deal.userfield.get",
          params
        );
        console.log({ steData });
        this.typeSTE = steData.data.result.LIST;
      } catch (error) {
        console.log({ error });
      }
    },
  },
  async mounted() {
    await this.getManager();
   // await this.getSTE();
  },
};
</script>
